import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_WORKS_HISTORY: 'GET_WORKS_HISTORY',
    GET_TRAININGS: 'GET_TRAININGS',
    GET_EDUCATIONS: 'GET_EDUCATIONS',
    GET_SKILLS: 'GET_SKILLS',
    ADD_WORK_ITEM: 'ADD_WORK_ITEM',
    ADD_TRAININGS_ITEM: 'ADD_TRAININGS_ITEM',
    ADD_EDUCATIONS_ITEM: 'ADD_EDUCATIONS_ITEM',
    DELETE_WORK_ITEM: 'DELETE_WORK_ITEM',
    DELETE_TRAININGS_ITEM: 'DELETE_TRAININGS_ITEM',
    DELETE_EDUCATIONS_ITEM: 'DELETE_EDUCATIONS_ITEM',
    UPDATE_WORK_ITEM: 'UPDATE_WORK_ITEM',
    UPDATE_TRAININGS_ITEM: 'UPDATE_TRAININGS_ITEM',
    UPDATE_EDUCATIONS_ITEM: 'UPDATE_EDUCATIONS_ITEM',
    UPDATE_SKILLS: 'UPDATE_SKILLS',
    GET_USER_DATA: 'GET_USER_DATA',
    UPLOAD_CV: 'UPLOAD_CV'
  })
};

export const getWorksHistory = createAsyncAction(types.GET_WORKS_HISTORY, () =>
  api.get(`v1/work-histories`).then((res) => res.data)
);

export const deleteWorkItem = createAsyncAction(types.DELETE_WORK_ITEM, (id) =>
  api.delete(`v1/work-history/${id}`).then((res) => ({ ...res.data, idDeleted: id }))
);

export const addWorkItem = createAsyncAction(types.ADD_WORK_ITEM, (work) =>
  api.post(`v1/work-history`, work).then((res) => ({ ...res.data, newWork: work }))
);

export const updateWorkItem = createAsyncAction(types.UPDATE_WORK_ITEM, (work) =>
  api.put(`v1/work-history/${work.Id}`, work).then((res) => ({ ...res.data, updatedWork: work }))
);

export const getTrainings = createAsyncAction(types.GET_TRAININGS, () =>
  api.get(`v1/training-certificates`).then((res) => res.data)
);

export const deleteTrainingsItem = createAsyncAction(types.DELETE_TRAININGS_ITEM, (id) =>
  api.delete(`v1/training-certificate/${id}`).then((res) => ({ ...res.data, idDeleted: id }))
);

export const addTrainingsItem = createAsyncAction(types.ADD_TRAININGS_ITEM, (training) =>
  api.post(`v1/training-certificate`, training).then((res) => ({ ...res.data, newTraining: training }))
);

export const updateTrainingsItem = createAsyncAction(types.UPDATE_TRAININGS_ITEM, (training) =>
  api
    .put(`v1/training-certificate/${training.Id}`, training)
    .then((res) => ({ ...res.data, updatedTraining: training }))
);

export const getEducations = createAsyncAction(types.GET_EDUCATIONS, () =>
  api.get(`v1/educations`).then((res) => res.data)
);

export const deleteEducationsItem = createAsyncAction(types.DELETE_EDUCATIONS_ITEM, (id) =>
  api.delete(`v1/education/${id}`).then((res) => ({ ...res.data, idDeleted: id }))
);

export const addEducationsItem = createAsyncAction(types.ADD_EDUCATIONS_ITEM, (education) =>
  api.post(`v1/education`, education).then((res) => ({ ...res.data, newEducation: education }))
);

export const updateEducationsItem = createAsyncAction(types.UPDATE_EDUCATIONS_ITEM, (education) =>
  api.put(`v1/education/${education.Id}`, education).then((res) => ({ ...res.data, updatedEducation: education }))
);

export const getSkills = createAsyncAction(types.GET_SKILLS, (userId) =>
  api.get(`v1/user/${userId}/my-skills`).then((res) => res.data)
);

export const updateSkillsItems = createAsyncAction(types.UPDATE_SKILLS, (userId, skills) =>
  api.put(`v1/user/${userId}/skills`, skills).then(() => skills)
);
